import React, { FC } from 'react'
import { createStyles, makeStyles } from '@zn-material-ui'
import Tabs from '@components/Tabs'
import { transform } from '@utils/intl_lang'
const useStyles = makeStyles(() =>
  createStyles({
    tabRoot: {
      width: 230,
      paddingLeft: 0,
      '& span:first-child': {
        alignItems: 'flex-start !important',
      },
    },
    root: {
      width: 460,
      marginTop: 40,
    },
    indicator: {
      height: 2,
    },
  })
)

export enum LoginTabEnum {
  'FREE_LOGIN' = '0',
  'NORMAL_LOGIN' = '1',
  'ENTERPRISE_LOGIN' = '2'
}
interface IProps {
  onTabChnage: (value: string) => void
  defaultValue: string
}

const tabs = [
  // '手机号登录'
  { label: transform('Login_pwd_free_login'), key: '0' },
  // '邮箱登录'
  { label: transform('Login_account_login'), key: '1' },
]

const LoginTab: FC<IProps> = props => {
  const classes = useStyles()
  return (
    <>
      <Tabs
        tabs={tabs}
        defaultValue={props.defaultValue}
        onTabChange={props.onTabChnage}
        align="flex-start"
        showShadow={false}
        classes={{
          root: classes.root,
          barIndicator: classes.indicator,
        }}
        tabProps={{
          classes: {
            root: classes.tabRoot,
          },
        }}
      />
    </>
  )
}

export default LoginTab
